import Domain from 'enums/Domain'
import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const authorVerifiedResolver: FieldResolver = (metadata: Metadata) =>
  ({
    authorVerified: metadata.getDomain() === Domain.TWITTER && metadata.isAuthorVerified()
  } as StreamData)

export default authorVerifiedResolver
